import { Button, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import style from './about-me.module.scss';
import { EditAboutMeDialog } from './edit-about-me-dialog';
import { useSelector } from 'react-redux';
import { GetUrlBuilderData } from 'store/url-builder';
import { RichTextEditor } from 'components/shared/rich-text-editor';

export interface AboutMeProps {
    builderType: string;
}


export const AboutMe = ({builderType}:AboutMeProps) => {
 const [editAboutMeDialog, setEditAboutMeDialog] = useState(false);
 const builderData = useSelector(GetUrlBuilderData);

 const openEditAboutMeDialog = () => setEditAboutMeDialog(true);
 const handleEditAboutMeDialogClose = () => setEditAboutMeDialog(false);

 return (
  <Grid item container xs={12}>
   <Grid item xs={12} className='mb-3'>
    <Button onClick={openEditAboutMeDialog} classes={{ root: style.root }} fullWidth>
     <AddIcon /> Add Text
    </Button>
   </Grid>
   {builderData.aboutMe.text && (
    <Grid item xs={12}>
     <RichTextEditor initialState={builderData.aboutMe.text} readonly />
    </Grid>
   )}
   {editAboutMeDialog && <EditAboutMeDialog isOpen onClose={handleEditAboutMeDialogClose} builderType={builderType}/>}
  </Grid>
 );
};
